import { Provider } from 'react-redux'
import { store } from './store/store'
import { ThemeProvider } from './components/theme-provider'
import { usePing } from '@/hooks/usePing'
import { useEffect } from 'react'
import { Toaster } from '@/components/ui/sonner'
import { toast } from 'sonner'
import { AuthProvider } from '@/contexts/AuthContext'
import { UserPlanProvider } from '@/contexts/UserPlanContext'
import { AnalyticsProvider } from '@/contexts/AnalyticsContext'
import { AppRoutes } from '@/routes/AppRoutes'

function App() {
  const { pingStatus } = usePing()

  // Show error toast for ping failures
  useEffect(() => {
    if (pingStatus.lastError) {
      toast.error(
        'Service connectivity issue. Some features may not work properly.',
      )
    }
  }, [pingStatus.lastError])

  return (
    <Provider store={store}>
      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
        <AuthProvider>
          <UserPlanProvider>
            <AnalyticsProvider>
              <AppRoutes />
              <Toaster position="top-center" closeButton richColors />
            </AnalyticsProvider>
          </UserPlanProvider>
        </AuthProvider>
      </ThemeProvider>
    </Provider>
  )
}

export default App
